<template>
	<inertia-head title="Group Insurance" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Group Insurance</h1>
					<p class="h4 fw-normal text-white-75 fs-sm">Group Insurance Management</p>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Filter by</label>
								<select
									v-model="form.filter_by_column"
									class="form-select form-select-sm"
								>
									<option value="username">Email</option>
									<option value="fname">First Name</option>
									<option value="lname">Last Name</option>
									<option value="counter">User ID</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Value</label>
								<input
									v-model="form.column_value"
									type="text"
									class="form-control form-control-sm"
								/>
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<label for="" class="form-label"></label>
							<div>
								<button type="submit" class="btn btn-alt-primary me-1">
									<i class="fa fa-search me-1"></i>
									Display
								</button>
								<button
									@click="$inertia.visit(route('admin.group-insurance'))"
									type="button"
									class="btn btn-alt-secondary"
								>
									<i class="fa fa-retweet me-1"></i>
									Reset
								</button>
							</div>
						</div>
					</div>

				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>NAME</th>
								<th>BIRTHDATE</th>
								<th>AGE</th>
								<th>RANK</th>
								<th>EXPIRY</th>
								<th>MOBILE</th>
								<th>REMARK</th>
								<th class="text-end">::::</th>
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(member, index) in members.data"
								:key="member.counter"
							>
								<td>
									{{member.fname}} {{member.lname}}
									<div><sub class="text-info">{{member.username}}</sub></div>
								</td>
								<td>{{member.bday}}</td>
								<td>{{member.age}}</td>
								<td>{{member.current_rank}}</td>
								<td>{{member.expiry}}</td>
								<td>{{member.mobile}}</td>
								<td>
									<span :class="{'text-success':member.status_remark=='Verification Complete','text-info':member.status_remark=='Verified but age is not eligible',
													'text-warning':member.status_remark=='For Approval','text-primary':member.status_remark=='For Verification','text-danger':member.status_remark=='Document is rejected',
													'text-elegance':member.status_remark=='Age is not eligible','text-muted':member.status_remark=='Info is not yet complete'
												}"
									>{{member.status_remark}}</span>
									<div v-if="member.is_docu_reupload==1"><sub class="text-warning">Re-upload</sub></div>
								</td>
								<td class="text-end">
									<button @click="modalToggle(index)" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-search"></i></button>
									<!-- <a target="_blank" type="button" class="btn btn-primary btn-sm ms-1" :href="'/admin/group-insurance/health-declaration/'+member.counter"><i class="fa fa-print text-bold"></i></a> -->
								</td>
							</tr>
							<tr v-if="members.data.length == 0">
								<td colspan="8" class="text-center text-danger p-3">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="members" />
			</div>
		</div>

		<group-insurance-modal ref="groupInsuranceModal" :api-response="api_response"></group-insurance-modal>

	</div>
</template>

<script>
import { onMounted, watch, ref } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import GroupInsuranceModal from '../../Components/Admin/GroupInsuranceModal'
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		members 	: Object,
		api_response: Object,
		errors		: Object
	},
	components:{GroupInsuranceModal},
	setup(props) {
		const action = ref('verify');
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const groupInsuranceModal = ref(null);

		const form = useForm({
			filter_by_column 	: 'username',
			column_value 		: '',
		})

		const submit = () => {
			form.get(route('admin.group-insurance'), {
				preserveState: true,
				preserveScroll: true,
				only:['members']
			})
		}

		const selectedMember = ref(null);

		const modalToggle = (_index)=>{

			selectedMember.value = props.members.data[_index];

			groupInsuranceModal.value.setMember(selectedMember.value);

			groupInsuranceModal.value.toggleModal();
		}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{	
				if(value.result=="success")
				{	
					var action_msg = groupInsuranceModal.value.action=='reject'?'rejected':(groupInsuranceModal.value.action=='approve'?'approved':'verified')
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+groupInsuranceModal.value.action, { type: "error"});
				}
			}
		})

		return {
			action,
			form,
			submit,
			selectedMember,
			groupInsuranceModal,
			modalToggle
		}
	},
}
</script>
